import { useShallow } from 'zustand/react/shallow';
import useProductDetailsStore from '../../../stores/ProductDetails/productDetails.store';

type OpenProductDetailsParams =
  | { kitId: string; orderIds?: string[] }
  | { productId: string; productColorId?: string; orderIds?: string[] };

const useProductDetailsLauncher = () => {
  const [setProductDetailsModalState, handleOpenProductDetailsModal, setFrom] =
    useProductDetailsStore(
      useShallow((state) => [
        state.setProductDetailsModalState,
        state.handleOpenProductDetailsModal,
        state.setFrom,
      ]),
    );

  const openProductDetails = (params: OpenProductDetailsParams) => {
    setFrom(undefined);

    if ('kitId' in params) {
      setProductDetailsModalState({ isOpen: true, kitId: params.kitId });
      handleOpenProductDetailsModal({ orderIds: params.orderIds });
      return;
    }

    setProductDetailsModalState({
      isOpen: true,
      productId: params.productId,
      productColorId: params.productColorId,
    });
    handleOpenProductDetailsModal({
      orderIds: params.orderIds,
      productColorId: params.productColorId,
      isFinishedOrder: false,
    });
  };

  return { openProductDetails };
};

export default useProductDetailsLauncher;
